import { Injectable } from "@angular/core";

@Injectable()
export class RouteDataService {
    data = [];
    isEditMode: boolean;
}
